// extracted by mini-css-extract-plugin
export default {"CardImage":"CardImage_CardImage__MzgzN","CardImage__img":"CardImage_CardImage__img__MDQwY"};